import { differenceInHours, format, subHours } from "date-fns";
import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { Api } from "../services/Api";
import { getConsultaBlackList, postAdicionaBlackList } from "../services/requests/creditCardRequests";
import { Pagamento, SalvaTermo, ValidaCartaoCreditoZoop } from "../services/requests/postPayment";
import { postProtestoAceite } from "../services/requests/postProtestAccept";
import { getLocal, setLocal } from "../utils/LocalStorageOps";
import { useAuth } from "./AuthInfoContext";
import { useGeneral } from "./GeneralInfoContext";
import { usePrivate } from "./PrivateInfoContext";

const NegotiationContext = createContext({});

function NegotiationInfo({ children }) {
  const { user_id } = useAuth();
  const {
    cobrancas,
    tipoPagamento,
    valorTotal,
    setReload,
    setLoading,
    parcelaValor,
    taxaEnvioProtesto,
    valorFeeProtesto,
    valorFeeProtestoDesconto,
    descontoMaxParcelas,
    valorComDesconto,
    valorTotalSemDesconto,
    setCobrancasSelecionadas,
    taxaPague,
    descontoTipo,
    boletoVencimento,
    providerWlan,
    entrada,
    taxaProtestoEntrada,
    taxaPrimeiraParcelaProtesto,
    cartaoBandeira,
    formataCartaoBandeira,
    cobrancasSelecionadas,
    mudaFormaPagamento,
    tipoNegociacao,
    devedorInfo
  } = usePrivate();
  const { today } = useGeneral();
  //const valorComDesconto = valorSemTaxaProtesto-desconto+valorFeeProtestoDesconto
  const [pdf, setPdf] = useState("");
  const [mostraTermo, setMostraTermo] = useState(false);
  const [mostraAtualizaEndereco, setMostraAtualizaEndereco] = useState(false);
  const [mostraCartaoCreditoDialog, setMostraCartaoCreditoDialog] = useState(false);
  const [mostraCartaoCreditoLinkDialog, setMostraCartaoCreditoLinkDialog] = useState(false);
  const [cartaoLinkID, setCartaoLinkID] = useState(null);
  const [mostraDownloadBoletoDialog, setMostraDownloadBoletoDialog] = useState(false);
  const [mostraConfirmacaoDias, setMostraConfirmacaoDias] = useState(false);
  const [cartaoRecusadoData, setCartaoRecusadoData] = useState([]);
  const [boletoData, setBoletoData] = useState([]);
  const [cartaoNumero, setCartaoNumero] = useState("");

  const aceitaProtesto = async (email) => {
    setLoading(true);
    try {
      for (let i = 0; i < cobrancas.length; i++) {
        const protestoData = {
          other_value: email,
          usuario_acao: "aceite no termo protesto",
          cobranca_id: cobrancas[i].cobranca_id,
        };
        await postProtestoAceite(protestoData);
      }
      setMostraTermo(true)
    } catch (error) {
      console.log(error);
      // toast.error('Erro ao salvar termo de protesto! Tente novamente mais tarde')
    } finally {
      setLoading(false);
    }
  };

  const aceitaProtestoParcial = async (email) => {
    setLoading(true);
    try {
      for (let i = 0; i < cobrancasSelecionadas.length; i++) {
        const protestoData = {
          other_value: email,
          usuario_acao: "aceite no termo de negociação parcial com protesto",
          cobranca_id: cobrancasSelecionadas[i].cobranca_id,
        };
        await postProtestoAceite(protestoData);
      }
      setMostraTermo(true)
    } catch (error) {
      console.log(error);
      // toast.error('Erro ao salvar termo de protesto! Tente novamente mais tarde')
    } finally {
      setLoading(false);
    }
  };

  const aceitaTermo = async (valor_a_pagar) => {
    setMostraTermo(false);
    if (tipoPagamento === "B") setMostraConfirmacaoDias(true);
    else {
      await geraLinkFixPay(valor_a_pagar);
    }
  };

  const geraLinkFixPay = async (valor_a_pagar) => {
    try {
      setLoading(true);
      const { data } = await Api.post("/cartao/gera_link", {
        usuario_id: user_id,
        valor: valor_a_pagar,
        numero_parcelas: parcelaValor.numero_parcela,
        cobranca_descricao: "Negociação Referente à ".concat(format(new Date(), "dd/MM/yyyy")),
      });
      setCartaoLinkID(data.split("/").pop());
      await new Promise((resolve) => setTimeout(resolve, 5000));
      await pagamentoCreditoLink(data.split("/").pop());
    } catch (error) {
      toast.error("Erro ao gerar pagamento");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  function criaPagamentoData() {
    const PAYMENT_METHOD_QUANTITY = 1;
    const [{ cobranca_id }] = cobrancas;
    console.log(valorTotal, valorTotalSemDesconto, valorComDesconto, descontoMaxParcelas, cartaoBandeira);
    return {
      array_cobrancas: cobrancasSelecionadas,
      tipo_negociacao: tipoNegociacao,
      cobranca_id,
      parcelas: parcelaValor.numero_parcela,
      tipo: "boleto",
      cobranca_qtd_meio_pagamento: PAYMENT_METHOD_QUANTITY,
      valor:
        Number(parcelaValor.numero_parcela) <= descontoMaxParcelas
          ? (valorComDesconto - (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0)).toFixed(2)
          : (valorTotalSemDesconto - (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0)).toFixed(2),
      token_card: "",
      fee_direto: 1,
      tipo_fee:
        Number(parcelaValor.numero_parcela) <= descontoMaxParcelas
          ? Number(valorFeeProtestoDesconto).toFixed(2)
          : Number(valorFeeProtesto).toFixed(2),
      fee_pague: taxaPague.toFixed(2),
      cartao_bandeira: formataCartaoBandeira(cartaoBandeira),
      taxa_envio_protesto: taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0,
      origem: tipoNegociacao === "total" ? "NEGOCIE TOTAL" : "NEGOCIE PARCIAL",
      dia_vencimento_boleto: boletoVencimento,
    };
  }

  const pagamentoBoleto = async () => {
    setLoading(true);
    // console.log(criaPagamentoData());
    try {
      const dataPagamento = criaPagamentoData();
      //console.log(dataPagamento)
      let data = [];
      if (providerWlan && entrada && tipoPagamento === "B") {
        dataPagamento.entrada = (entrada * 0.99 - 2.9).toFixed(2);
        dataPagamento.entrada_fee = taxaProtestoEntrada;
        //console.log(dataPagamento)
        data = await Pagamento(dataPagamento);
      } else data = await Pagamento(dataPagamento);
      try {
        await handleTerm({
          base64: pdf,
          boleto_id: data[0].id,
        });
        setLoading(false);
        setBoletoData(data);
        setReload((prevState) => !prevState);
        toast.success("Sua negociação foi gerada com sucesso! Baixe o primeiro boleto agora");
        setMostraDownloadBoletoDialog(true);
        mudaFormaPagamento(null);
        setCobrancasSelecionadas([]);
      } catch (error) {
        setLoading(false);
        toast.error("Erro ao salvar termo, tente novamente mais tarde");
        console.log(error);
      }
      //console.log(data)
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao gerar boleto, tente novamente mais tarde");
      console.log(error);
    }
  };

  //Função para gerar o hash de cartão de crédito na Zoop
  const cartaoValidacao = async (cardData) => {
    setLoading(true);
    let cartao_blacklist = false;
    try {
      const blacklist_body = {
        usuario_id: user_id,
        cartao_primeiro: cardData.card_number.slice(0, 4),
        cartao_ultimo: cardData.card_number.slice(12, 16),
      };
      const retorno_blacklist = await getConsultaBlackList(blacklist_body);
      if (retorno_blacklist.length === 0) cartao_blacklist = false;
      else {
        const data_bloqueio = subHours(new Date(retorno_blacklist.created_at), 3);
        const diferenca_dias = differenceInHours(today, data_bloqueio);
        cartao_blacklist = diferenca_dias > 24 ? false : true;
      }
    } catch (error) {
      console.log(error);
      cartao_blacklist = false;
    }
    if (!cartao_blacklist) {
      try {
        const data = await ValidaCartaoCreditoZoop(cardData);
        await pagamentoCredito(data.id, cardData);
        //console.log(data);
      } catch (error) {
        console.log(error);
        if (error.response === undefined) return toast.error("Erro de Conexão!");
        if (error.response.status === 500) toast.error("Serviço de verificação de cartão indisponível!");
        if (error.response.status === 402) toast.error("Cartão inválido verifique os campos!");
      } finally {
        setLoading(false);
      }
    } else {
      toast.warn(
        "Este cartão está impedido de realizar negociações na plataforma por 24 horas devido ao excesso de tentativas"
      );
      setLoading(false);
    }
  };

  async function pagamentoCreditoLink(token) {
    try {
      const dataPagamento = criaPagamentoData();
      dataPagamento.token_card = token;
      dataPagamento.cartao_bandeira = formataCartaoBandeira(cartaoBandeira);
      dataPagamento.tipo = "cartao";
      const data = await Pagamento(dataPagamento);
      await handleTerm({
        base64: pdf,
        boleto_id: data[0].id,
      });
      setReload((prevState) => !prevState);
      //setMostraCartaoCreditoLinkDialog(false);
      toast.success("Negociação gerada com sucesso! Uma nova aba será aberta para vc realizar o pagamento em cartão");
      setMostraCartaoCreditoLinkDialog(true);
      window.open("https://gateway.fixpay.com.br/payment/" + token, "_blank", "noopener, noreferrer");
    } catch (error) {
      console.log("Erro cartão:::: ", error.response);
      setMostraCartaoCreditoLinkDialog(false);
      return toast.error("Erro ao gerar negociação");
    }
  }

  async function pagamentoCredito(token, cardData) {
    setLoading(true);
    try {
      const dataPagamento = criaPagamentoData();
      dataPagamento.token_card = token;
      dataPagamento.cartao_bandeira = formataCartaoBandeira(cartaoBandeira);
      dataPagamento.tipo = "cartao";
      const data = await Pagamento(dataPagamento);
      await handleTerm({
        base64: pdf,
        boleto_id: data[0].id,
      });
      setReload((prevState) => !prevState);
      setMostraCartaoCreditoDialog(false);
      toast.success("Negociação gerada com sucesso!");
      //setShowCartaoConfirmaDialog(true)
      //console.log(data)
    } catch (error) {
      console.log("Erro cartão:::: ", error.response);
      setLoading(false);
      setCartaoRecusadoData(cardData);
      if (cardData.card_number === cartaoRecusadoData.card_number) {
        const repetido = getLocal("CartaoRepetido");
        setLocal("CartaoRepetido", repetido + 1);
        if (repetido + 1 > 3) {
          setLocal("CartaoRepetido", 0);
          bloqueiaCartao(cardData.card_number);
        } else
          toast.error(
            "Erro ao gerar pagamento, este cartão já foi recusado anteriormente, caso este cartão seja negado novamente, ele ficará indisponpivel para uso na plataforma por 24 horas"
          );
      }

      if (error.response === undefined)
        return toast.error("Erro ao gerar pagamento com cartão, tente novamente mais tarde");
      if (error.response.status === 500) return toast.error("Erro de conexão com o servidor!");
      if (error.response.data.category === "card_declined")
        return toast.error(
          "Cartão recusado, por favor entre em contato com seu banco ou gestor de crédito para mais informações!"
        );
      if (error.response.data.category === "insufficient_funds_error")
        return toast.error("Cartão recusado, saldo insuficiente!");
      return toast.error("Erro ao gerar pagamento com cartão, tente novamente mais tarde!");
    } finally {
      setLoading(false);
    }
  }

  async function bloqueiaCartao(cardNumber) {
    const blacklist_body = {
      usuario_id: user_id,
      cartao_4primeiros_digitos: cardNumber.slice(0, 4),
      cartao_4ultimos_digitos: cardNumber.slice(12, 16),
    };
    try {
      await postAdicionaBlackList(blacklist_body);
      toast.warn("Este cartão não poderá ser utilizado nesta plataforma por 24 horas, entre em contato com o SAC");
    } catch (error) {
      console.log(error);
    }
  }

  function termoData(base64) {
    if (base64) {
      setPdf(base64);
    }
  }

  async function handleTerm(object) {
    try {
      await SalvaTermo(object);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <NegotiationContext.Provider
      value={{
        aceitaProtesto,
        aceitaProtestoParcial,
        aceitaTermo,
        cartaoValidacao,
        cartaoRecusadoData,
        termoData,
        pdf,
        setPdf,
        cartaoNumero,
        setCartaoNumero,
        mostraTermo,
        setMostraTermo,
        mostraAtualizaEndereco, 
        setMostraAtualizaEndereco,
        mostraCartaoCreditoDialog,
        setMostraCartaoCreditoDialog,
        mostraDownloadBoletoDialog,
        setMostraDownloadBoletoDialog,
        mostraConfirmacaoDias,
        setMostraConfirmacaoDias,
        mostraCartaoCreditoLinkDialog,
        setMostraCartaoCreditoLinkDialog,
        cartaoLinkID,
        setCartaoLinkID,
        pagamentoBoleto,
        pagamentoCreditoLink,
        boletoData,
      }}
    >
      {children}
    </NegotiationContext.Provider>
  );
}

function useNegotiation() {
  const context = useContext(NegotiationContext);
  return context;
}

export { NegotiationInfo, useNegotiation };
